export const environment = {
  production: true,
  api: {
    // baseUrl: 'http://clients.foodxain.com/api/'
    // baseUrl: 'http://localhost:4000/api/v1/'
    // baseUrl: 'https://foodxain-backend.onrender.com/api/v1/',
    baseUrl: 'https://foodxain-backend.mobiledokanpro.com/api/v1/'
  }
};
